export default {
      id: "ic-nav-home-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-nav-home-usage",
      toString: function () {
        return this.url;
      }
    }